import { render, staticRenderFns } from "./spinner-xl.vue?vue&type=template&id=98800c3e&scoped=true"
import script from "./spinner-xl.vue?vue&type=script&lang=js"
export * from "./spinner-xl.vue?vue&type=script&lang=js"
import style0 from "./spinner-xl.vue?vue&type=style&index=0&id=98800c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98800c3e",
  null
  
)

export default component.exports